import {Injectable} from '@angular/core';
import {AbstractDataServiceV2} from '../../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {PrescriptionModel} from '../../../api/model/prescription.model';
import {PrescriptionConverter} from '../../../api/model/converter/prescription.converter';
import {HttpClient} from '@angular/common/http';
import {CustomizeHttpUrlGenerator} from '../../../../../../../store/core/url/customizeHttpUrlGenerator';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';


@Injectable({providedIn: 'root'})
export class PrescriptionDataService extends AbstractDataServiceV2<PrescriptionModel, PrescriptionConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: PrescriptionConverter) {
        super('Prescription', http, httpUrlGenerator, logger, config, converter);
    }
}
